import * as React from 'react';

import { useSelector } from 'react-redux';

import { OffersBlock } from '../../components/OffersBlock';
import { OffersHeader } from '../../components/OffersHeader';
import { OffersMarks } from '../../components/OffersMarks';

import { getDisplayName } from '../../selectors/newbuilding';
import { getOffers } from '../../selectors/offers';

import { EscrowBlockContainer } from '../EscrowBlockContainer';
import { HousesFilterContainer } from '../HousesFilter';
import { LayoutsOrTourEntry } from '../LayoutsOrTourEntry/LayoutsOrTourEntry';
import { OffersContainer } from '../OffersAB';
import { PriceRelevance } from '../PriceRelevance';
import { ReliableBlockContainer } from '../ReliableBlock';
import { SalesStartInfoContainer } from '../SalesStartInfo';
import { trackDeveloperFlatsLinkClick } from './tracking';

export function OffersBlockContainer() {
  const { fromDeveloperPropsCountDisplay, fromDeveloperPropsCountUrl, fromAgentsPropsCountDisplay } =
    useSelector(getOffers);
  const newbuildingName = useSelector(getDisplayName);

  if (!fromAgentsPropsCountDisplay && !fromDeveloperPropsCountDisplay) {
    return null;
  }

  return (
    <OffersBlock
      title={
        <OffersHeader
          fromDeveloperPropsCountDisplay={fromDeveloperPropsCountDisplay}
          fromDeveloperPropsCountUrl={fromDeveloperPropsCountUrl}
          newbuildingName={newbuildingName}
          onLinkClick={trackDeveloperFlatsLinkClick}
          salesStartInfo={<SalesStartInfoContainer />}
        />
      }
      priceRelevance={<PriceRelevance />}
      offers={
        <>
          <HousesFilterContainer />
          <OffersContainer />
          <OffersMarks>
            <ReliableBlockContainer />
            <EscrowBlockContainer />
          </OffersMarks>
        </>
      }
      layoutsEntry={<LayoutsOrTourEntry />}
    />
  );
}

OffersBlockContainer.displayName = 'OffersBlockContainerAB';
